// components/MultiPlatformPixelScript/fallback.tsx — Noscript fallback img tags (Meta)
import React from 'react';
import type { MultiPlatformPixelScriptProps } from './types';

export function MetaNoscriptFallback({ configs, contentName, orderData }: Pick<MultiPlatformPixelScriptProps, 'configs' | 'contentName' | 'orderData'>) {
    const metaPixelIds = configs
        .filter(c => c.platform === 'meta')
        .flatMap(c => c.pixelIds)
        .filter(id => id?.trim());

    if (metaPixelIds.length === 0) return null;

    const imgEventName = configs.find(c => c.platform === 'meta')?.eventName || 'ViewContent';
    const makeImgTags = (ids: string[], keyPrefix: string) =>
        ids.map(id => {
            const pageViewParams = new URLSearchParams();
            pageViewParams.append('id', id);
            pageViewParams.append('ev', 'PageView');
            pageViewParams.append('noscript', '1');

            const eventParams = new URLSearchParams();
            eventParams.append('id', id);
            eventParams.append('ev', imgEventName);
            eventParams.append('noscript', '1');
            eventParams.append('cd[currency]', 'IDR');
            if (contentName) eventParams.append('cd[content_name]', contentName);
            if (orderData) {
                eventParams.append('cd[value]', String(orderData.value));
                eventParams.append('cd[order_id]', orderData.orderId);
            }

            return (
                <React.Fragment key={`${keyPrefix}-${id}`}>
                    <img height="1" width="1" style={{ display: 'none' }} src={`https://www.facebook.com/tr?${pageViewParams.toString()}`} alt="" />
                    <img height="1" width="1" style={{ display: 'none' }} src={`https://www.facebook.com/tr?${eventParams.toString()}`} alt="" />
                </React.Fragment>
            );
        });

    return (
        <>
            <noscript>
                {makeImgTags(metaPixelIds, 'ns')}
            </noscript>
        </>
    );
}
